<template>
  <div class="phy_wrap">
    <div v-if="!showDetail">
      <div class="dis-wrap-top">
        <div class="tit">{{company_id == 170 || company_id == 171?'疾病提示':'疾病风险'}}</div>
        <div class="text">
          <p>“</p>
          通过数据分析，为您筛查出一些数据风险,<br />
          希望您早日关注身体状况，及时改善健康
          <p>”</p>
        </div>
      </div>
      <div class="cont-de">
        <template v-for="item in diseaseList">
          <div
            class="risk-bar"
            v-if="diseaseList.length != 0"
            :key="item.name"
            @click="toDetails(item)"
          >
            <div class="cont-left">
              <div class="name">{{ item.name }}</div>
              <div class="risk">有{{ item.status }}风险</div>
            </div>
            <!-- <img :src="ossUrl + '/diseasa/' + item.title + '.png'" /> -->
            <van-image
              class="imgmy"
              :src="ossUrl + '/diseasa/' + item.title + '.png'"
              width="30"
              height="30"
              style="margin-right: 5px"
              :error-icon="ossUrl + '/quanlizi.png'"
            >
            </van-image>
          </div>
        </template>
        <no-data
          no-text="暂无疾病风险 请继续保持~"
          v-show="diseaseList.length == 0"
        ></no-data>
      </div>
    </div>
    <template v-if="showDetail">
      <div class="details">
        <div class="dis-top">
          <div
            class="back"
            @click="
              showDetail = false;
              details = {};
            "
          >
            返回
          </div>
          <div class="text">
            <p>{{ details.name }}</p>
            (有{{ details.status }}风险)
          </div>
        </div>
        <div class="dis_title">
          <img src="../assets/image/disease/dis-icon1.png" />
          <span>定义</span>
        </div>
        <div class="jy">{{ details.definition }}</div>

        <div class="dis_title">
          <img class="icon" src="../assets/image/disease/dis-icon2.png" />
          <span>相关症状</span>
        </div>
        <div class="jy">{{ details.symptom }}</div>

        <div class="dis_title">
          <img class="icon" src="../assets/image/disease/dis-icon3.png" />
          <span>改善建议</span>
        </div>
        <div class="jy" v-for="text in details.references" :key="text">
          {{ text }}
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import EchartsBar from '@/components/EchartsBar'
import lineAndBar from "@/components/lineAndBar"
import NoData from '@/components/NoData'
import NewText from "./NewText"
import LevelBar from "./LevelBar"
import { ossUrl } from "@/config";

export default {
  props: ['list'],
  components: { EchartsBar, lineAndBar, NewText, LevelBar, NoData },
  data () {
    return {
      diseaseList: [],
      details: {},
      showDetail: false,
      ossUrl,
      company_id:localStorage.getItem('company_id')
    }
  },
  created () {
    this.hanldeObJToArr(this.list)
  },
  methods: {
    hanldeObJToArr (obj) {
      console.log(obj)
      const arr = []
      for (let key in obj) {
        arr.push(
          {
            ...obj[key],
            title: key
          })
      }
      const pd = arr.some(e => e.name)
      if (pd) {
        arr.forEach(e => {
          e.references = e.references ? e.references.split('\\r\\n') : []
          if (e.name) {
            this.diseaseList.push(e)
          }
        })
      } else {
        this.diseaseList = []
      }
      console.log(this.diseaseList)
    },
    toDetails (item) {
      this.showDetail = true;
      this.details = item
    },
  },
}
</script>
<style lang="scss" scoped>
.phy_wrap {
  position: relative;
  width: 100%;
  margin: auto;
  background-color: #fff;
}
.dis-wrap-top {
  width: 100%;
  padding: 45px 10px;
  background-color: rgb(108, 216, 108);
  color: #fff;
  font-size: 32px;
  box-sizing: border-box;
  .tit {
    margin-bottom: 20px;
    font-size: 32px;
  }
  .text {
    width: 480px;
    margin: auto;
  }
  p {
    font-size: 50px;
    margin: 0;
    &:first-child {
      text-align: left;
    }
    &:last-child {
      text-align: right;
      margin-top: 20px;
    }
  }
}
.cont-de {
  position: relative;
  min-height: 800px;
  padding: 35px 20px;
}
.risk-bar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 25px;
  box-shadow: 0 0 6px 0 #ddd;
  padding: 20px;
  border-radius: 5px;
  img {
    width: 70px;
    height: 70px;
  }
  .cont-left {
    .name {
      font-size: 32px;
      color: #333;
      text-align: left;
      margin-bottom: 10px;
    }
    .risk {
      font-size: 30px;
      color: #ff4f4f;
      font-weight: bold;
      text-align: left;
    }
  }
}
.details {
  .dis-top {
    position: relative;
    background-image: url(../assets/image/disease/title_bg.png);
    background-size: auto 100%;
    height: 260px;
    width: 100%;
    .back {
      position: absolute;
      top: 20px;
      left: 20px;
      background-color: #fff;
      width: 100px;
      height: 52px;
      border-radius: 4px;
      line-height: 52px;
    }
    .text {
      position: absolute;
      top: 0;
      left: 80px;
      bottom: 0;
      margin: auto 0;
      text-align: center;
      color: #ff4f4f;
      font-weight: bold;
      font-size: 36px;
      height: 100px;
      p {
        font-size: 42px;
        margin: 0;
      }
    }
  }
  .dis_title {
    width: 700px;
    margin: auto;
    font-size: 34px;
    color: #616161;
    margin: 30px auto 25px;
    text-align: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    color: #000;
    img {
      width: 40px;
      margin-right: 20px;
    }
  }
}

.jy {
  width: 700px;
  margin: 0 auto 25px;
  padding: 0 10px;
  text-align: left;
  padding-bottom: 30px;
  font-size: 32px;
  border-bottom: 1px dashed #ddd;
}
.risk-status {
  margin: 15px auto 0;
  width: 350px;
}
</style>